<template>
  <div id="home">
    <div class="home-content content">
      <div class="hc-top clear">
        <banner />
        <art />
      </div>
      <div class="hc-icon clear">
        <icon />
      </div>
      <div class="hc-title">
        <template-content />
      </div>
    </div>
  </div>
</template>

<script>
import Art from "./atrTemplate.vue";
import Banner from "./bannerTemplate";
import Icon from "./iconTemplate";
import TemplateContent from "./teamTemplate";
export default {
  name: "Home",
  components: { Banner, Art, Icon, TemplateContent },
};
</script>

<style scoped lang="scss">
.home-content {
  margin: 36px auto 0;
  .hc-top {
    @include wh(100%, 304px);
  }
  .setting-home {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 19px;
    .s-h-text {
      margin-right: 10px;
      color: #3c3c43;
      font-size: 14px;
    }
    .save {
      @include wh(100px, 34px);
      margin-left: 34px;
      background: linear-gradient(180deg, #646470 0%, #3c3c4b 100%);
      border-radius: 8px;
      line-height: 34px;
      text-align: center;
      color: #fff;
      font-weight: 400;
    }
  }
  .hc-icon {
    margin-top: 6px;
  }
}
</style>
